module.exports = __webpack_public_path__ + "static/media/ste_2009_avezzano_4.60ef22fb.jpg";